
import { Component, Vue } from 'vue-property-decorator';
import { OrderStage } from '@/types/reportOrder';
import OrderList from '@/components/OrderList/index.vue';
import OrderSearch from '@/components/OrderSearch/index.vue';

@Component({
  name: 'OrderCustomerUnconfirmed',
  components: {
    OrderList,
    OrderSearch
  }
})
export default class extends Vue {
 private stage = OrderStage.UNCOMMENT;
}
